/* eslint-disable @typescript-eslint/no-explicit-any */
import { EditableComponent } from '@adobe/aem-react-editable-components';
import relatedArticlesMock from './___mock__/mock.json';
import { StyledRelatedArticlesContainer } from './RelatedArticles.styles';
/* eslint-disable @nx/enforce-module-boundaries */
import { CardCarouselContainer, CardHorizontalFeature } from '@marriott/mi-ui-library';
import {
  articleFetchTypeDynamic,
  articleFetchTypeManual,
  fullbleedClass,
  relatedArticlesNormal,
  relatedArticlesWithHorizontalFeature,
  primaryTopicSelectorLabel,
  deployedEnvTypeLower,
} from '../../modules/utils/constants/constants';
import { useContext, useEffect, useState } from 'react';
import clsx from 'clsx';
import axios from 'axios';
import { PageParamsContext } from '../../modules/context/PageContext';
import { getSubDirectoryLocale } from '../../modules/utils/helpers';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';

const { NEXT_PUBLIC_AEM_SITE } = process.env;

export const RelatedArticles = (props: any) => {
  const { currentLocale, primaryTopic, deployedEnvType } = useContext(PageParamsContext);
  const subLocale = getSubDirectoryLocale(currentLocale || 'en-US');
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isComponentReady, setIsComponentReady] = useState<boolean>(false);
  const [cardCarouselProps, setCardCarouselProps] = useState<any>({});
  const [articleCategory, setArticleCategory] = useState<string>('');

  useEffect(() => {
    const getArticleDetails = async () => {
      const dispatcherDomain =
        process.env['AEM_API_DISPATCHER_URL'] ||
        useClientEnvVarsStore.getState().envVarsObject['AEM_API_DISPATCHER_URL'];
      const componentName = props?.cqType?.slice(props?.cqType?.lastIndexOf('/') + 1);
      const topicSelector =
        props?.componentVariation === relatedArticlesWithHorizontalFeature
          ? props?.articleSearchType
          : primaryTopicSelectorLabel;

      const topic = encodeURIComponent(
        props?.componentVariation === relatedArticlesWithHorizontalFeature ? props?.topicTagName : primaryTopic
      ).replaceAll('%', '_');

      const aemAPIURL =
        deployedEnvType === deployedEnvTypeLower
          ? `${dispatcherDomain}.${currentLocale?.toLowerCase()}.${componentName}.${topicSelector}.${topic}.${
              props?.cardCount
            }.json`
          : `/services/marriott-awp/traveler/related-articles/v1.${currentLocale?.toLowerCase()}.${componentName}.${topicSelector}.${topic}.${
              props?.cardCount
            }.json`;

      try {
        const response = await axios.get(aemAPIURL);
        if (response.data?.relatedArticles?.length > 0) {
          generateCarouselProps(response.data?.relatedArticles);
        } else {
          setIsLoading(false);
          setIsComponentReady(false);
        }
      } catch (error) {
        setIsLoading(false);
        setIsComponentReady(false);
      }
    };
    if (props?.isAuthorMode) {
      generateCarouselProps(relatedArticlesMock?.relatedArticles);
    } else {
      if (
        (props?.componentVariation === relatedArticlesWithHorizontalFeature &&
          props?.authoringType === articleFetchTypeDynamic) ||
        props?.componentVariation === relatedArticlesNormal
      ) {
        getArticleDetails();
      } else if (
        props?.componentVariation === relatedArticlesWithHorizontalFeature &&
        props?.authoringType === articleFetchTypeManual
      ) {
        generateCarouselProps(props?.relatedArticles);
      }
    }
  }, [props?.isAuthorMode]);

  const generateCarouselProps = (articlesList: any) => {
    const cqItems = articlesList?.map((article: any) => {
      return {
        ':items': {
          [props.cardTypes]: {
            dynamicMedia: article?.imageURL,
            cardVerticalVariations: props?.cardVariation,
            trackingProperties: {},
            isAuthor: false,
            ':type': `mi-aem-common-spa/components/content/${props.cardTypes}`,
            header: article?.title,
            ctaLink: `${subLocale}/${article?.ctaLink}.mi`,
            openInNewTab: props?.cardLinkIsOpenInNewTab,
            styleclass: props?.cardsStyleClass || '',
          },
        },
      };
    });

    const cqItemsList = Object.fromEntries(cqItems.map((item: any, key: number) => [`card-${key}`, item]));

    const updatedProps = {
      ...props?.model,
      cqItems: cqItemsList,
      cqItemsOrder: Object.keys(cqItemsList),
      totalNumberOfCards: Object.keys(cqItemsList),
      cardCount: articlesList?.length,
      styleclass: props?.styleclass?.includes(fullbleedClass) ? fullbleedClass : '',
      isAuthorMode: false,
      allowedComponents: props?.allowedComponents,
    };
    setCardCarouselProps(updatedProps);
    setArticleCategory(articlesList[0]?.TopicTitle);
    setIsLoading(false);
    if (articlesList?.length > 2 && Object.keys(updatedProps)?.length > 0) {
      setIsComponentReady(true);
    } else setIsComponentReady(false);
  };

  if (isLoading) return <div className={clsx('m-spinner-m')} data-testid="map-loader"></div>;

  if (isComponentReady)
    return (
      <StyledRelatedArticlesContainer
        category={props?.componentVariation === relatedArticlesWithHorizontalFeature ? '' : articleCategory}
        className={props?.styleclass}
      >
        <div className="container">
          {props?.componentVariation === relatedArticlesWithHorizontalFeature && (
            <CardHorizontalFeature {...{ ...props, styleclass: props?.styleclass?.replaceAll(fullbleedClass, '') }} />
          )}
          <CardCarouselContainer {...cardCarouselProps} />
        </div>
      </StyledRelatedArticlesContainer>
    );
  else return null;
};

export const RelatedArticlesConfig = {
  emptyLabel: 'relatedarticles',
  isEmpty: false,
  resourceType: `${NEXT_PUBLIC_AEM_SITE}/components/content/traveler/relatedarticles`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RelatedArticlesEditable = (props: any) => (
  <EditableComponent config={RelatedArticlesConfig} {...props}>
    <RelatedArticles {...props} />
  </EditableComponent>
);
